import React from 'react';
import { Route } from 'react-router-dom';
import CardGrid from '../../GlobalSettings/CardsGrid.js';
import VersionChange from '../../GlobalSettings/GlobalSettingFiles/VersionChange.js';
import MetadataChange from '../../GlobalSettings/GlobalSettingFiles/MetadataChange.js';
import DisinfectionTimedata from '../../GlobalSettings/GlobalSettingFiles/DisinfectionTime.js';
import Viewimage from '../../GlobalSettings/GlobalSettingFiles/viewimage.js';
import { guardRoute } from '../ProtectedRoute';

export const globalSettingsRoutes = [
  <Route key="card-global" path="/card-global" element={guardRoute(<CardGrid />, '/card-global')} />,
  <Route
    key="update-version"
    path="/update-Version"
    element={guardRoute(<VersionChange />, '/update-Version')}
  />,
  <Route
    key="metadata-change"
    path="/metadata-Change"
    element={guardRoute(<MetadataChange />, '/metadata-Change')}
  />,
  <Route
    key="disinfection-time"
    path="/disinfectionTime"
    element={guardRoute(<DisinfectionTimedata />, '/disinfectionTime')}
  />,
  <Route key="view-image" path="/Viewimage" element={guardRoute(<Viewimage />, '/Viewimage')} />,
];
